import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

import { DIContainer } from "@/app.container";
import dataStore from "@/store";

const name = "CustomerPreviewStore";

if ((dataStore.state as any)[name]) {
  dataStore.unregisterModule(name);
}

@Module({ name, dynamic: true, store: dataStore })
export default class CustomerPreviewStore extends VuexModule {
  plushiesProcessing: string[] = [];

  // ################################### COMMANDS EXECUTION #########################################

  get isPlushieProcessing(): (plushieId: string) => boolean {
    return (plushieId: string) => this.plushiesProcessing.includes(plushieId);
  }

  @Mutation
  markPlushieAsProcessing(plushieId: string) {
    if (this.plushiesProcessing.includes(plushieId)) {
      return;
    }

    this.plushiesProcessing.push(plushieId);
  }

  @Mutation
  removePlushieProcessingMark(plushieId: string) {
    const index = this.plushiesProcessing.indexOf(plushieId);

    if (index === -1) {
      return;
    }

    this.plushiesProcessing.splice(index, 1);
  }

  @Action({ rawError: true })
  async createCustomerPreviewApprovement(plushieId: string): Promise<void> {
    this.markPlushieAsProcessing(plushieId);

    try {
      await DIContainer.CustomerPreviewRepository.createCustomerPreviewApprovement(
        plushieId
      );

      await this.context.dispatch("refreshPlushie", plushieId);
    } finally {
      this.removePlushieProcessingMark(plushieId);
    }
  }

  @Action({ rawError: true })
  async createCustomerPreviewRejection({
    plushieId,
    comment,
    attachments,
  }: {
    plushieId: string;
    comment: string;
    attachments: string[];
  }): Promise<void> {
    this.markPlushieAsProcessing(plushieId);

    try {
      await DIContainer.CustomerPreviewRepository.createCustomerPreviewRejection(
        plushieId,
        comment,
        attachments
      );

      await this.context.dispatch("refreshPlushie", plushieId);
    } finally {
      this.removePlushieProcessingMark(plushieId);
    }
  }

  @Action({ rawError: true })
  async undoCustomerPreviewApprovement(plushieId: string): Promise<void> {
    this.markPlushieAsProcessing(plushieId);

    try {
      await DIContainer.CustomerPreviewRepository.undoCustomerPreviewApprovement(
        plushieId
      );

      await this.context.dispatch("refreshPlushie", plushieId);
    } finally {
      this.removePlushieProcessingMark(plushieId);
    }
  }
}
